module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8019.bfc897c3.png";